export const RolesContants = {
    ADMIN: "ADMIN",
    LOAN_OFFICER: "LOAN_OFFICER",
    LOAN_OFFICER_AUTHORIZER: "LOAN_OFFICER_AUTHORIZER",
    LOAN_OFFICER_HEAD: "LOAN_OFFICER_HEAD",
    MART_OFFICER: "MART_OFFICER",
    MART_OFFICER_HEAD: "MART_OFFICER_HEAD",
}